var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    fill: "currentColor",
    viewBox: "0 0 16 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 1.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M.25 3a2.75 2.75 0 0 1 5.397-.75H15a.75.75 0 0 1 0 1.5H5.647A2.751 2.751 0 0 1 .25 3M13 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-2.646.5a2.751 2.751 0 1 1 0 1.5H1a.75.75 0 0 1 0-1.5z"
  })));
};
export default SvgFilterIcon;